
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Table from './table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "table"
    }}>{`Table`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Tables`}</p>
    <hr />
    <h2 {...{
      "id": "table-1"
    }}>{`Table`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For presenting data sets in a structured layout. Headers are styled differently to data;
both use lining figures (Econ Sans).`}</p>
    <Playground __position={1} __code={'<Table>\n  <thead>\n    <tr>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td>Row1 Cell1</td>\n      <td>Row1 Cell2</td>\n      <td>Row1 Cell3</td>\n      <td>Row1 Cell4</td>\n    </tr>\n    <tr>\n      <td>Row2 Cell1</td>\n      <td>Row2 Cell2</td>\n      <td>Row2 Cell3</td>\n      <td>Row2 Cell4</td>\n    </tr>\n    <tr>\n      <td>Row3 Cell1</td>\n      <td>Row3 Cell2</td>\n      <td>Row3 Cell3</td>\n      <td>Row3 Cell4</td>\n    </tr>\n    <tr>\n      <td>Row4 Cell1</td>\n      <td>Row4 Cell2</td>\n      <td>Row4 Cell3</td>\n      <td>Row4 Cell4</td>\n    </tr>\n  </tbody>\n</Table>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Table
    }} mdxType="Playground">
    <Table mdxType="Table">
        <thead>
            <tr>
              <th scope='col'>Heading</th>
              <th scope='col'>Heading</th>
              <th scope='col'>Heading</th>
              <th scope='col'>Heading</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Row1 Cell1</td>
                <td>Row1 Cell2</td>
                <td>Row1 Cell3</td>
                <td>Row1 Cell4</td>
            </tr>
            <tr>
                <td>Row2 Cell1</td>
                <td>Row2 Cell2</td>
                <td>Row2 Cell3</td>
                <td>Row2 Cell4</td>
            </tr>
            <tr>
                <td>Row3 Cell1</td>
                <td>Row3 Cell2</td>
                <td>Row3 Cell3</td>
                <td>Row3 Cell4</td>
            </tr>
            <tr>
                <td>Row4 Cell1</td>
                <td>Row4 Cell2</td>
                <td>Row4 Cell3</td>
                <td>Row4 Cell4</td>
            </tr>
        </tbody>
    </Table>
    </Playground>
    <hr />
    <h2 {...{
      "id": "table-scroll"
    }}>{`Table (scroll)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For presenting data sets in a structured layout. Headers are styled differently to data;
both use lining figures (Econ Sans).`}</p>
    <Playground __position={3} __code={'<Table scroll>\n  <thead>\n    <tr>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n      <th scope=\"col\">Heading</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td>Row1 Cell1</td>\n      <td>Row1 Cell2</td>\n      <td>Row1 Cell3</td>\n      <td>Row1 Cell4</td>\n      <td>Row1 Cell5</td>\n      <td>Row1 Cell6</td>\n      <td>Row1 Cell7</td>\n      <td>Row1 Cell8</td>\n    </tr>\n    <tr>\n      <td>Row2 Cell1</td>\n      <td>Row2 Cell2</td>\n      <td>Row2 Cell3</td>\n      <td>Row2 Cell4</td>\n      <td>Row2 Cell5</td>\n      <td>Row2 Cell6</td>\n      <td>Row2 Cell7</td>\n      <td>Row2 Cell8</td>\n    </tr>\n    <tr>\n      <td>Row3 Cell1</td>\n      <td>Row3 Cell2</td>\n      <td>Row3 Cell3</td>\n      <td>Row3 Cell4</td>\n      <td>Row3 Cell5</td>\n      <td>Row3 Cell6</td>\n      <td>Row3 Cell7</td>\n      <td>Row3 Cell8</td>\n    </tr>\n    <tr>\n      <td>Row4 Cell1</td>\n      <td>Row4 Cell2</td>\n      <td>Row4 Cell3</td>\n      <td>Row4 Cell4</td>\n      <td>Row4 Cell5</td>\n      <td>Row4 Cell6</td>\n      <td>Row4 Cell7</td>\n      <td>Row4 Cell8</td>\n    </tr>\n  </tbody>\n</Table>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Table
    }} mdxType="Playground">
    <Table scroll mdxType="Table">
    <thead>
        <tr>
          <th scope='col'>Heading</th>
          <th scope='col'>Heading</th>
          <th scope='col'>Heading</th>
          <th scope='col'>Heading</th>
          <th scope='col'>Heading</th>
            <th scope='col'>Heading</th>
            <th scope='col'>Heading</th>
            <th scope='col'>Heading</th>
        </tr>
      </thead>
      <tbody>
          <tr>
            <td>Row1 Cell1</td>
            <td>Row1 Cell2</td>
            <td>Row1 Cell3</td>
            <td>Row1 Cell4</td>
            <td>Row1 Cell5</td>
            <td>Row1 Cell6</td>
            <td>Row1 Cell7</td>
            <td>Row1 Cell8</td>
          </tr>
          <tr>
            <td>Row2 Cell1</td>
            <td>Row2 Cell2</td>
            <td>Row2 Cell3</td>
            <td>Row2 Cell4</td>
            <td>Row2 Cell5</td>
            <td>Row2 Cell6</td>
            <td>Row2 Cell7</td>
            <td>Row2 Cell8</td>
          </tr>
          <tr>
            <td>Row3 Cell1</td>
            <td>Row3 Cell2</td>
            <td>Row3 Cell3</td>
            <td>Row3 Cell4</td>
            <td>Row3 Cell5</td>
            <td>Row3 Cell6</td>
            <td>Row3 Cell7</td>
            <td>Row3 Cell8</td>
          </tr>
          <tr>
            <td>Row4 Cell1</td>
            <td>Row4 Cell2</td>
            <td>Row4 Cell3</td>
            <td>Row4 Cell4</td>
            <td>Row4 Cell5</td>
            <td>Row4 Cell6</td>
            <td>Row4 Cell7</td>
            <td>Row4 Cell8</td>
          </tr>
        </tbody>
    </Table>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Table} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;